@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  --search-input-max-inline-size: 400px;
  display: grid;
  block-size: 100%;
}
:host(:not(.has-footer)) {
  grid-template-rows: max-content 1fr;
}
:host(.has-footer) {
  grid-template-rows: max-content 1fr max-content;
}

.header.has-active-item {
  grid-area: header;
}

.section {
  display: contents;
}

// header
.header {
  &__first-row,
  &__second-row {
    display: grid;
    grid-auto-flow: column;
  }
  &__first-row {
    grid-auto-columns: max-content;
  }
  &__second-row {
    grid-template-columns:
      minmax(150px, var(--search-input-max-inline-size))
      max-content;

    &--one-row {
      grid-template-columns: minmax(150px, var(--search-input-max-inline-size));
    }
  }
}

.active-item {
  background-color: var(--color-accent-surface-elevation-1);
  border-radius: 4px;
  padding: var(--control-padding-block) var(--control-padding-inline);
  display: flex;
  align-items: center;
  gap: var(--spacing-gap-m);
}
.active-item {
  &__icon-container {
    display: contents;
  }
  &__icon {
    pointer-events: none; // We do not want the icon to change the colors, since the clickable area is the caption only
  }
  &__link {
    text-decoration: underline;
    // TODO: There should be a class in Merucry to apply link styles
    color: var(--color-text-primary-default);
    cursor: pointer;
    &:hover {
      color: var(--color-text-primary-hover);
    }
    &:active {
      color: var(--color-text-primary-pressed);
    }
  }
}

.trees {
  position: relative;
}
